import React from 'react';
import * as d3 from "d3";
import * as d3ScaleChromatic from "d3-scale-chromatic";

window.d3 = d3;
var rect  ={};
var color = '#2196f3';

class Calendar extends React.Component {

    componentDidMount() {

        if (this.props.activities.length > 0) {
            this.display(this.props.activities);
        }

    }

    display(activities) {

        if(activities.length===0){
            d3.select(this.container).selectAll('g').remove();
            return;
        }

            var min = activities.reduce(function(prev, curr) {
                return prev.distance < curr.distance ? prev : curr;            
            });
            var max = activities.reduce(function(prev, curr) {
                return prev.distance > curr.distance ? prev : curr;
            });

        
            var minDistance = min.distance;
            var maxDistance = max.distance;
        console.log(minDistance+" "+maxDistance)

        var poster = this.props.poster;

        var width = poster.layout.width,
        height = poster.layout.height,
        cellSize = 17; // cell size

        var no_months_in_a_row = Math.floor(width / (cellSize * 7 + cellSize * 7*.2));
        var shift_up = cellSize * 3;

        var day = d3.timeFormat("%w"); // day of the week
        //var day_of_month = d3.timeFormat("%e"); // day of the month
        //var day_of_year = d3.timeFormat("%j");
        var week = d3.timeFormat("%U"); // week number of the year
        var month = d3.timeFormat("%m"); // month number
        var year = d3.timeFormat("%Y");
        //var percent = d3.format(".1%");
        var format = d3.timeFormat("%Y-%m-%d");

        /*var color = d3.scale.quantize()
            .domain([-.05, .05])
            .range(d3.range(11).map(function(d) { return "q" + d + "-11"; }));*/

        var startYear = new Date(activities[0].start_date).getFullYear()

        d3.select(this.container).selectAll('g').remove();

        

        var svg = d3.select(this.container).selectAll('g')
            .data([startYear])
            .enter()
            .append("g")
            .attr("width", width)
            .attr("height", height)
            .attr("class", "RdYlGn")

        rect = svg.selectAll(".day")
            .data(function (d) {
                console.log(d);
                return d3.timeDays(new Date(d, 0, 1), new Date(d + 1, 0, 1));
            })
            .enter().append("rect")
            .attr("class", "day")
            .attr("width", cellSize)
            .attr("height", cellSize)
            .attr("x", function (d) {
                var month_padding = 1.2 * cellSize * 7 * ((month(d) - 1) % (no_months_in_a_row));
                return day(d) * cellSize + month_padding + (poster.layout.width-(cellSize*7*no_months_in_a_row+.2 * cellSize * 7*(no_months_in_a_row-1)))/2;
            })
            .attr("y", function (d) {
                var week_diff = week(d) - week(new Date(year(d), month(d) - 1, 1));
                var row_level = Math.ceil(month(d) / (no_months_in_a_row));
                return (week_diff * cellSize) + row_level * cellSize * 8 - cellSize / 2 - shift_up -45 /*Shoudl be calculated*/;
            })
            .datum(format);

            var style = poster.style;
            color = style.route.color;
        //rect.style("fill", function (d) { return "#000"; });
        activities.forEach(function (activity) {
            console.log(d3ScaleChromatic.interpolateSpectral((activity.distance-minDistance)/(maxDistance-minDistance)));
            
            rect.filter(function (d) { return d === activity.start_date.split('T')[0]; })
                //.style("fill", function (d) { return d3ScaleChromatic.interpolateSpectral((activity.distance-minDistance)/(maxDistance-minDistance))});
                .style("fill", function (d) { return style.route.color; })
                .style("opacity", function (d) { return ((activity.distance-minDistance)/(maxDistance-minDistance))/2+0.5; });
        });
    }

    shouldComponentUpdate(nextProps) {
        if(this.props.poster.style.route.color!==color){
            this.display(nextProps.activities);
            return true;
        }
        if (this.props.activities.length !== nextProps.activities.length) {
            this.display(nextProps.activities);
            return true
        }
        if (this.props.activities.length > 0 && this.props.activities[0].id === nextProps.activities[0].id) {
            return false
        } else {
            if (nextProps.activities.length > 0) {
                this.display(nextProps.activities);
            }

            return true
        }
    }

    render() {
        return (

            <g id='calendar' ref={(node) => this.container = node} />
        )
    }
}

export default Calendar;


// WEBPACK FOOTER //
// ./src/components/Calendar.js